import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2978fa4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-[40px] tw-self-stretch tw-bg-[#FCFCFD]" }
const _hoisted_2 = { class: "tw-w-[100%] tw-flex tw-flex-col tw-gap-[12px] !tw-break-inside-avoid" }
const _hoisted_3 = {
  id: "chr-sheading-stats",
  class: "tw-text-[#211F58] tw-text-[24px] tw-font-semibold tw-font-[Poppins] tw-w-fit"
}
const _hoisted_4 = { class: "tw-text-[#231F20] tw-text-[14px] tw-font-[Poppins] tw-font-normal tw-opacity-[0.7]" }
const _hoisted_5 = { class: "tw-flex tw-gap-[20px] tw-flex-col tw-w-full stats-container" }
const _hoisted_6 = { class: "tw-flex tw-w-full tw-gap-[20px] md:tw-flex-row tw-flex-col stats-row" }
const _hoisted_7 = {
  key: 1,
  class: "custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
}
const _hoisted_8 = {
  key: 3,
  class: "custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
}
const _hoisted_9 = {
  key: 5,
  class: "custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
}
const _hoisted_10 = {
  key: 7,
  class: "custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
}
const _hoisted_11 = { class: "tw-flex tw-w-full tw-gap-[20px] lg:tw-flex-row tw-flex-col stats-row" }
const _hoisted_12 = { class: "tw-max-w-[225px] tw-min-w-[225px] tw-flex tw-gap-[10px]" }
const _hoisted_13 = { class: "tw-text-[#211F58] tw-font-[Poppins] tw-text-[35px] tw-font-semibold tw-leading-[100%]" }
const _hoisted_14 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-[130%]" }
const _hoisted_15 = { class: "vertical-rl tw-flex tw-items-center tw-h-full" }
const _hoisted_16 = {
  key: 1,
  class: "custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
}
const _hoisted_17 = { class: "tw-max-w-[213px] tw-flex tw-gap-[15px]" }
const _hoisted_18 = { class: "tw-text-[#211F58] tw-font-[Poppins] tw-text-[35px] tw-font-semibold tw-leading-[100%]" }
const _hoisted_19 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-[130%]" }
const _hoisted_20 = {
  key: 3,
  class: "custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
}
const _hoisted_21 = {
  key: 5,
  class: "custom-global-skeleton tw-flex tw-w-full tw-h-[130px]"
}

import AssessmentValueCard from "@/components/share/assessmentValueCard.vue";
import { getComponentUiText } from "@/utils/utilities";
import { computed } from "vue";
import RadialProgressBar from "../prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentStatus',
  props: {
  isLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const checklistReportData = computed(
  () => store.getters["Sharing/getChecklistReportData"],
);

const servicesData = computed(() => store.state.Sharing.servicesData);

const currentOrg = computed(() => store.state.Org.currentOrg);

const checklistDate = computed(() => {
  return store.state.Sharing.checklistReportData?.checklistSummary
    ?.checklistDate;
});

const scoreImprovementPersent = computed(() => {
  const value =
    checklistReportData.value?.checklistInfographics
      ?.checklistInfographicsScoreImprovement * 100;
  return (
    (value ? (Number.isInteger(value) ? value : value.toFixed(1)) : 0) + "%"
  );
});

const valueOtherWebservicesCard = computed(() => {
  if (currentOrg.value.id === servicesData.value?.idOrg) {
    const valueServices =
      (servicesData.value?.sections &&
        servicesData.value?.sections[0]?.questions[0]?.values) ||
      [];
    const checklistDateToMs = new Date(checklistDate.value).getTime();

    const datafilter = valueServices.filter((item) => {
      const startDateToMs = item.startDate
        ? new Date(item.startDate).getTime()
        : new Date().getTime();
      const endDateToMs = item.endDate
        ? new Date(item.endDate).getTime()
        : new Date().getTime();

      return (
        startDateToMs <= checklistDateToMs && endDateToMs >= checklistDateToMs
      );
    });

    return datafilter.length;
  }

  return 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-share-cyber-profile-stats-title-1")), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
            "app-landing-share-assessments-status-description-1",
          )), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (!__props.isLoading)
          ? (_openBlock(), _createBlock(AssessmentValueCard, {
              key: 0,
              title: 
            _unref(getComponentUiText)(
              'app-landing-share-assessments-status-card-title-carried-1',
            )
          ,
              value: 
            checklistReportData.value?.checklistInfographics
              ?.checklistInfographicsHistoryCount
              ? checklistReportData.value?.checklistInfographics
                  ?.checklistInfographicsHistoryCount
              : 0
          
            }, null, 8, ["title", "value"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7)),
        (!__props.isLoading)
          ? (_openBlock(), _createBlock(AssessmentValueCard, {
              key: 2,
              title: 
            _unref(getComponentUiText)(
              'app-landing-share-assessments-status-card-title-wep-app-1',
            )
          ,
              value: 
            checklistReportData.value?.checklistInfographics
              ?.checklistInfographicsWebservicesCount
          
            }, null, 8, ["title", "value"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8)),
        (!__props.isLoading)
          ? (_openBlock(), _createBlock(AssessmentValueCard, {
              key: 4,
              title: 
            _unref(getComponentUiText)(
              'app-landing-share-assessments-status-card-title-other-services-1',
            )
          ,
              value: valueOtherWebservicesCard.value
            }, null, 8, ["title", "value"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9)),
        (!__props.isLoading)
          ? (_openBlock(), _createBlock(AssessmentValueCard, {
              key: 6,
              title: 
            _unref(getComponentUiText)(
              'app-landing-share-assessments-status-card-title-audit-assess-1',
            )
          ,
              value: 
            checklistReportData.value?.checklistInfographics
              ?.checklistInfographicsItemCount
          
            }, null, 8, ["title", "value"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10))
      ]),
      _createElementVNode("div", _hoisted_11, [
        (!__props.isLoading)
          ? (_openBlock(), _createBlock(AssessmentValueCard, {
              key: 0,
              title: 
            _unref(getComponentUiText)(
              'app-landing-share-assessments-status-card-title-audit-category-1',
            )
          
            }, {
              value: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(checklistReportData.value?.checklistInfographics
                    ?.checklistInfographicsCatGt75) + "/" + _toDisplayString(checklistReportData.value?.checklistCategories?.length), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(getComponentUiText)(
                    "app-landing-share-assessments-status-card-audit-category-note-1",
                  )), 1)
                ])
              ]),
              rightContent: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(RadialProgressBar, {
                    class: "d-inline",
                    "total-steps": 100,
                    "completed-steps": 
                  (checklistReportData.value?.checklistInfographics
                    ?.checklistInfographicsCatGt75 /
                    checklistReportData.value?.checklistCategories?.length) *
                  100
                ,
                    "is-hide-progress": true,
                    "diameter-default": 80,
                    "is-hide-responsive": false,
                    "inner-stroke-color": "#F7553C"
                  }, null, 8, ["completed-steps"])
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16)),
        (!__props.isLoading)
          ? (_openBlock(), _createBlock(AssessmentValueCard, {
              key: 2,
              title: 
            _unref(getComponentUiText)(
              'app-landing-share-assessments-status-card-title-low-cost-1',
            )
          
            }, {
              value: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(checklistReportData.value?.checklistInfographics
                    ?.checklistInfographicsItemsLt90), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(getComponentUiText)(
                    "app-landing-share-assessments-status-card-low-cost-note-1",
                  )), 1)
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_20)),
        (!__props.isLoading)
          ? (_openBlock(), _createBlock(AssessmentValueCard, {
              key: 4,
              title: 
            _unref(getComponentUiText)(
              'app-landing-share-assessments-status-card-title-improvement-assessment-1',
            )
          ,
              "custom-class": `${
            Number(scoreImprovementPersent.value.replace('%', '')) < 0
              ? 'tw-text-[#F7553C]'
              : ''
          }`,
              value: scoreImprovementPersent.value
            }, null, 8, ["title", "custom-class", "value"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21))
      ])
    ])
  ]))
}
}

})